module.exports = __webpack_public_path__ + "static/media/platzi.fe80a616.png";